/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';
import {FloatingLabelTextField} from 'shells/floating-label-textfield';

type Props = FieldProps & {
    label: string,
};

export function TextField(props: Props) {
    const {input, label, ...rest} = props;

    // Wrap FloatingLabelTextField in extra div to preserve proper styling
    return (
        <div>
            <FloatingLabelTextField
                {...rest}
                name={input.name}
                value={input.value}
                onBlur={input.onBlur}
                onChange={(newVal) => {
                    input.onChange(newVal);
                }}
                onFocus={(e: any) => {
                    input.onFocus(e);
                }}
                label={label}
            />
        </div>
    );
}
